import React from 'react';
import { testimonials } from '../data/mock';
import { Quote } from 'lucide-react';

export const Testimonials = () => {
  return (
    <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h2 className="hero-medium" style={{ marginBottom: '16px' }}>
            What Our Travelers Say
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Experiences that exceed expectations, journeys that transform perspectives.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '32px'
        }}>
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              style={{
                background: 'var(--bg-secondary)',
                padding: '40px 32px',
                borderRadius: 0,
                position: 'relative',
                transition: 'transform 0.2s ease'
              }}
              className="hover-lift"
            >
              <Quote
                size={32}
                style={{
                  color: 'var(--border-light)',
                  marginBottom: '24px'
                }}
              />
              <p className="body-large" style={{ 
                marginBottom: '24px',
                lineHeight: 1.7,
                fontStyle: 'italic',
                color: 'var(--text-primary)'
              }}>
                "{testimonial.quote}"
              </p>
              <div style={{
                borderTop: '1px solid var(--border-light)',
                paddingTop: '16px'
              }}>
                <p className="body-regular" style={{ 
                  fontWeight: 700,
                  marginBottom: '4px',
                  color: 'var(--text-primary)'
                }}>
                  {testimonial.author}
                </p>
                <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                  {testimonial.location} • {testimonial.type}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
